var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2897 4.75892C20.86 4.71974 20.48 5.03635 20.4408 5.46604L20.3373 6.60155C18.581 3.84349 15.5324 1.99997 12 1.99997C8.19999 1.99997 4.85111 4.16881 3.18868 7.42397C2.99243 7.80823 3.14485 8.27882 3.52911 8.47507C3.91345 8.67132 4.38396 8.51894 4.58021 8.13464C5.98713 5.37979 8.81241 3.56247 12 3.56247C14.9054 3.56247 17.5274 5.07541 19.0295 7.44561L17.9155 6.65002C17.5644 6.39928 17.0765 6.48061 16.8257 6.83171C16.575 7.18284 16.6563 7.67073 17.0074 7.92151L20.3853 10.3341C20.8804 10.687 21.5633 10.3639 21.6174 9.76925L21.9968 5.60791C22.036 5.17818 21.7194 4.7981 21.2897 4.75892Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4709 15.5249C20.0866 15.3287 19.6161 15.4811 19.4198 15.8654C18.0129 18.6202 15.1876 20.4375 12 20.4375C9.09463 20.4375 6.47267 18.9246 4.97055 16.5544L6.0845 17.35C6.43564 17.6007 6.92353 17.5194 7.17431 17.1683C7.42505 16.8172 7.34373 16.3293 6.99263 16.0785L3.61469 13.6659C3.12566 13.3166 2.4373 13.63 2.38261 14.2307L2.00328 18.3921C1.9641 18.8218 2.2807 19.2018 2.71035 19.241C3.14059 19.2801 3.52016 18.9632 3.5593 18.5339L3.66281 17.3984C5.41899 20.1565 8.4676 22 12 22C15.8 22 19.1489 19.8312 20.8114 16.576C21.0076 16.1918 20.8552 15.7212 20.4709 15.5249Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.cfb298070c04a275a7f60f6b86e9f640.svg";
export { ForwardRef as ReactComponent };